module.exports = __webpack_public_path__ + "static/6315-fbb241375ed133a27fb0ae94b07796cc.png";